export default __webpack_public_path__ + "static/media/background.9261775c.jpg";